import { useContext } from 'react'
import AuthorizationContext from './AuthorizationProvider.context'

/**
 * The authorization custom hook.
 */
export const useAuthorization = () => {
  const { isValid } = useContext(AuthorizationContext)
  return { isValid }
}
